module.exports = {
  "CS_info2_Network_Image_HvHe": "صورة على موقع إلكتروني",
  "CS_one_Batch_configuration_Ffmp": "تهيئة المجموعة",
  "CS_5_When_the_PbND": "مُقدِّم الشكوى هو الراكب، لذا لا يمكن استخدام سوى أدوات الراكب.",
  "CS_one_Scenario_ENG_mFbn": "السيناريو (ar_EG)",
  "CS_info_Comments_failed_mQNX": "يتعذّر إضافة تعليق",
  "CS_5_Do_not_kYRj": "أنت تفعل ذلك كثيرًا جدًا",
  "CS_2_It_is_vdcu": "يُرجى الرد عبر الرسالة الواردة إلى التطبيق (سيتم أيضًا إرسال إشعار عبر البريد الإلكتروني). إذا كنت لا تعرف كيفية إجراء ذلك، يُرجى الاستفسار من مشرفك.",
  "CS_1_Template_oNtV": "قالب",
  "CS_tickets_User_Type_Wdya": "نوع المستخدم",
  "CS_info2_Please_fill_uLvw": "يُرجى الإدخال...",
  "CS_one_Operation_Log_hsdo": "سجل الإجراءات",
  "CS_one_Tips_vbZx": "تنبيه",
  "CS_one_Upload_successfully_DliZ": "تم تحميل الملف بنجاح، وبعده إنشائه سيسري في الدولة ذات الصلة. يُرجى إخطار الزملاء المعنيين في الدولة المحددة.",
  "CS_info2_Cancel_link_vxaa": "إزالة الرابط",
  "CS_1_Action_pnrH": "الإجراءات",
  "CS_pop_The_conversation_dKAF": "وقت بدء المكالمة",
  "CS_one_Upload_files_TzsC": "تحميل ملف",
  "CS_1_Operational_results_nOpZ": "نتيجة الإجراء",
  "CS_one_Please_check_SuZo": "2. حمِّل القالب المكتمل (تأكد من أن كل المعلومات التي أدخلتها صحيحة قبل التحميل).",
  "CS_1_Temporary_CTPp": "حفظ مؤقتًا",
  "CS_1_Solved_ooGh": "تم حل المشكلة",
  "CS_page_Unable_to_aXip": "يتعذر إنشاء تذكرة الدعم",
  "CS_one_Enter_rfGy": "يُرجى الإدخال",
  "CS_1_Message_Title_AJzH": "موضوع البريد الإلكتروني",
  "CS_2_Worksheet_ID_SxiT": "تم إنشاء معرّف تذكرة الدعم بناءً على إنشاء التذكرة",
  "CS_2_Copy_the_hSGF": "تم نسخ رقم الجوّال. تم تسجيل هذا الإجراء. يُرجى تذكر الالتزام بسياسات أمان المعلومات المتبعة لدى الشركة.",
  "CS_one_Classification_of_qEgR": "إدارة سبب التواصل",
  "ark.global.cs.field.values.ticket_tab_im": "محادثة مباشرة",
  "CS_qa_This_behavior_dZrQ": "تمت إضافة العمليات التي جرت في هذه الصفحة إلى السجل. يُرجى اتباع سياسات أمن المعلومات المتبعة لدى الشركة.",
  "CS_Page_Driver_List_Uxwj": "قائمة الشركاء الكباتن",
  "CS_1_Thank_you_WUlL": "شكرًا على تعليقك!",
  "CS_info_Select_Question_QkZC": "يُرجى تحديد \"سبب اتصال\"",
  "CS_5_Your_query_uvJB": "بلغت الحد الأقصى للاستفسارات",
  "CS_one_Determination_GUbi": "تأكيد",
  "CS_buchong_eFit_JNbR": "يتعذّر العثور على معلومات الطلب لأن رقم الجوّال غير صالح أو لأن المستخدم غير مُسّجل.",
  "CS_Page_Rider_Details_Ovwp": "تفاصيل الراكب: رقم تعريف الراكب",
  "CS_1_Amount_mYAW": "المبلغ",
  "CS_Page_Order_Details_oAUq": "تفاصيل المشوار: رقم تعريف المشوار",
  "CS_Adjustment_YdjN_bXSL": "سبب تخطي SOP غير ملائم. يُرجى اختيار سبب آخر.",
  "CS_Adjustment_gjOY_YpxQ": "معلومات SOP غير متسقة مع معلومات PC",
  "Fleet_0303_Fleet_WorkRegime_Contents_TAuX": "لا يوجد محتوى",
  "CS_buchong__yLly": "يتعذّر استخدام الأدوات نظرًا لأن رقم الجوّال غير صالح أو لأن المستخدم غير مُسّجل",
  "CS_one_Batch_effective_prPl": "التحقق من المجموعة",
  "CS_one_Country_and_Qyqv": "تهيئة الدولة وخط العمل",
  "CS_page_Please_fill_ikWU": "يُرجى تحديد \"مجموعة التذكرة\"",
  "CS_tickets_Three_days_pcmE": "آخر 3 أيام",
  "CS_one_New_Batch_wEKW": "إنشاء مجموعة",
  "CS_one_Abandoned_ROgG": "تم التجاهل",
  "CS_1_Enter_content_haAO": "أدخِل النص هنا",
  "CS_one_Description_ENG_vIZz": "الوصف (ar_EG)",
  "CS_page_Work_orders_MRDt": "تم إغلاق تذكرة الدعم بنجاح",
  "CS_one_Translation_configuration_lnQZ": "تهيئة الترجمة",
  "CS_tickets_Compensation_deduction_GJfV": "طريقة التعويض/الخصم",
  "CS_info_Like_failure_mPup": "حدثت مشكلة. يُرجى إعادة المحاولة.",
  "CS_info2_Make_sure_zyfT": "قبل تحديد هذا الخيار، يُرجى التأكد من عدم توفّر معلومات المدينة لتذكرة الدعم هذه.",
  "verify---id_no_co": "تحقق",
  "Help_version_Business_lines_VOJX": "الفئة",
  "CS_Page_Driver_Type_UnIR": "نوع الشريك الكابتن",
  "CS_information_Order_Basis_WKGU": "معلومات المشوار الأساسية",
  "Magellan_improvement_The_company_CoIp": "تعتبر المعلومات، مثل سجل الاتصال والرسالة الفورية، بيانات سرية تملكها الشركة. الرجاء استخدامها بحصافة وفقًا للوائح أمان المعلومات المتبعة لدينا. سيتم من خلال النظام تسجيل كل استعلام. يحظر نهائيًا التقاط صور لهذه البيانات أو تنزيلها أو الإفصاح عنها لطرف ثالث خارج الشركة.",
  "CS_Page_Passenger_Details_vgGv": "صفحة تفاصيل الراكب",
  "CS_Service_The_driver's_JbyZ": "كان مستوى الكابتن {{driver_level}} عندما تم إنشاء تذكرة الدعم تلك",
  "CS_pop_No_xtIB": "لا",
  "CS_pop_Cancel_byla": "إلغاء",
  "Magellan_improvement_IM_Information_weuP": "معلومات الرسالة الفورية",
  "CS_info2_Reset_Fiiu": "إعادة تعيين",
  "CS_1_E_mail_rKAg": "البريد الإلكتروني",
  "CS_tickets_Administrator_BcHW": "مدير الأسطول",
  "CS_one_Action_Type_uHTo": "نوع الإجراء",
  "Magellan_improvement_Question_description_GyVD": "وصف المشكلة",
  "CS_page_Do_you_UfOG": "هل تريد نقل تذكرة الدعم إلى {{ticketgroup}}؟",
  "CS_page_Transportation_orders_UWhR": "نقل تذكرة الدعم",
  "CS_tickets_One_month_IrdR": "آخر شهر",
  "CS_5_Unchecked_user_vuUZ": "معلومات تسجيل المستخدم غير موجودة",
  "CS_Settings_Countless_lEdc": "لا بيانات",
  "CS_page_Transferring_the_ZnkX": "تم نقل تذكرة الدعم بنجاح",
  "Magellan_improvement_Call_completed_hbKz": "اكتمل الاتصال",
  "CS_improvement_Passenger_JnXD": "الراكب",
  "CS_Page_Driver_Basic_SItd": "معلومات الكابتن الأساسية",
  "CS_one_Description_NrBC": "الوصف",
  "CS_Adjustment_abEf_PYol": "هناك مشكلة في SOP",
  "CS_4_Tools_can_ZQSK": "تقتصر إمكانية استخدام جميع الأدوات على صفحة معالجة تذكرة الدعم بنظام خدمة العملاء",
  "CS_one_Owner_EwUa": "المالك",
  "CS_Page_Model_List_WVIO": "قائمة فئات السيارات",
  "CS_Page_Common_tools_FTJG": "الأدوات الشائعة",
  "CS_info_Click_here_MKRf": "انقر هنا لربط طلب واحد",
  "CS_thpoptimization__sSiH": "أسطول السيارات",
  "CS_3_Optional_kdMP": "اختيارية",
  "CS_pop_User_Phone_hTGd": "رقم هاتف المستخدم",
  "CS_Page_City_name_atjF": "اسم المدينة",
  "CS_Service_Driver_Level_qpqY": "مستوى الكابتن",
  "CS_improvement_Call_SmCo": "وقت الاتصال",
  "Help_version_Enter_number_MyWJ": "رقم الهاتف الوارد",
  "CS_1_Comments_RcMN": "إرسال",
  "CS_info_This_page_Cpww": "تفاديًا لتأخر النظام، لا يمكن فتح إلا ما يصل إلى 10 علامات تبويب من تذاكر الدعم في هذه الصفحة. يُرجى إغلاق علامات التبويب غير الضرورية. شكرًا لك!",
  "CS_tickets_Work_order_NQJE": "حالة التذكرة",
  "CS_one_Entered_into_mEwl": "سارٍ",
  "CS_Adjustment_txhj_lfbO": "يُرجى إكمال SOP قبل المتابعة",
  "CS_tickets_Three_months_Jdzc": "آخر 3 أشهر",
  "CS_1_Order_ID_bsCY": "رقم تعريف الطلب",
  "CS_tool_Work_order_LjeC": "حالة التذكرة",
  "CS_Page_Trip_Compl_Vcnk": "وقت انتهاء المشوار",
  "CS_page_No_permissions_mYZG": "ليس لديك الإذن بنقل تذكرة الدعم هذه",
  "CS_1_Send_email_DDPi": "تأكيد إرسال رسالة البريد الإلكتروني",
  "CS_buchong__BYdr": "يتعذر العثور على معلومات المستخدم أو استخدام ميزة التحقق من الأذونات الديناميكية نظرًا لأن رقم الجوّال غير صحيح أو لأن المستخدم غير مُسجل.",
  "CS_one_New_Problem_ORNp": "إنشاء سبب تواصل جديد",
  "CS_Page_Select_the_kqHS": "يُرجى تحديد شروط الفلترة",
  "Help_version_Country_XKEj": "الدولة",
  "CS_translation_Selection_of_yatg": "حدد سبب التعويض",
  "CS_2_Please_select_Zapc": "يُرجى التحديد",
  "CS_2_Refund_amount_ikWV": "المبلغ المسترد",
  "CS_Page_Enter_Order_TeQM": "أدخل معرّف المشوار",
  "CS_Page_Type_SnKr": "الموديل",
  "CS_QA1_More_than_uScx": "إذا زادت الإدخالات عن {{amount}}، سيتم عرض {{amount}} من الإدخالات فقط.",
  "CS_one_Operation_Records_bTgJ": "سجل الإجراءات",
  "CS_1_ID_VNVI": "معرف تذكرة الدعم",
  "CS_pop_Bind_session_qEwk": "إضافة مكالمة",
  "CS_info2_Jump_link_pUcH": "رابط إعادة التوجيه",
  "CS_tickets_The_user_iVJx": "يشغل هذا المستخدم منصب مدير أسطول السيارات (انقر لعرض التفاصيل)",
  "ark.global.cs.field.values.ticket_tab_compensation": "سجل المعالجة",
  "CS_info2_Depositary_UmEY": "الممثل المختص بالتذكرة",
  "CS_initialization_Create_a_xRhB": "يُرجى إنشاء تذكرة دعم أولاً",
  "CS_pop_Bind_lDQM": "إضافة",
  "CS_Page_Order_List_IiWy": "قائمة المشاوير",
  "CS_one_Status_QWZW": "الحالة",
  "CS_information_Single_phone_vKdi": "رقم هاتف الطالب",
  "CS_2_Driver_balance_otCh": "الخصم من رصيد السائق",
  "CS_Notice_Please_submit_iVZB": "يُرجى تقديم تعليقاتك بشأن بطاقة المعالجة هذه قبل الإرسال",
  "CS_info2_Link_kBeS": "الربط",
  "CS_1_You_do_Czvx": "ليس لديك الإذن لعرض معلومات العملاء الخاصة. يُرجى تنفيذ التحقق عبر النظام أو الاتصال بالمسؤول.",
  "CS_info_Process_cards_ccmd": "بطاقة المعالجة",
  "CS_improvement_The_main_DIgv": "أنهى المتصل",
  "Help_2_More_OZUg": "المزيد",
  "CS_1_Recipients_jNBa": "إلى",
  "CS_buchong1__XPiG": "لا يمكن تنفيذ هذا الإجراء نظرًا لتعذر المصادقة الديناميكية. يُرجى إكمال المصادقة الديناميكية أو الاتصال بالمسؤول.",
  "CS_Page_Enter_email_VDKC": "أدخل عنوان بريد إلكتروني",
  "CS_one_Return_axWQ": "رجوع",
  "CS_tickets_Complaint_Manner_UWAQ": "تذكرة دعم مرتبطة بالمشكو منه",
  "CS_2_Refundable_mKnQ": "هل يمكن رد المال؟",
  "CS_pop_Whether_to_tvgd": "هل تودّ إنشاء تذكرة دعم دون إجراء مكالمة ذات صلة؟",
  "CS_1_Send_an_oyHo": "هل تريد بالتأكيد إرسال رسالة البريد الإلكتروني إلى هذا المستخدم؟",
  "CS_one_Upload_failed_tubs": "تعذّر التحميل، يُرجى إعادة المحاولة.",
  "CS_tickets_Order_Work_UDue": "تذكرة دعم مرتبطة بطلب",
  "Magellan_improvement_ID_HTMT": "رقم تعريف تذكرة الدعم",
  "CS_Page_Type_of_Chyl": "نوع الاستعلام",
  "CS_initialization_Select_user_QGGG": "يُرجى تحديد نوع المستخدم",
  "Help_version_Answer_DVQw": "الرد",
  "CS_improvement_Dial_man_vuMm": "المتصل",
  "CS_one_Are_you_QXby": "هل ترغب فعلاً في تعديل سبب التواصل المحدد؟ بعد تعديل سبب التواصل، سيسري في الدولة ذات الصلة. يُرجى إخطار الزملاء المعنيين في الدولة المحددة.",
  "CS_info2_Data_Not_mVCx": "لا توجد بيانات متاحة",
  "CS_information_Purpose_tIXL": "وجهة",
  "CS_Page_Response_mode_tfSQ": "وضع الرد",
  "CS_Page_Order_Status_ZJEQ": "حالة الطلب",
  "CS_1_Internal_message_Dmzz": "رسالة داخلية",
  "CS_1_More_online_ugOQ": "المزيد من سجل المحادثة",
  "CS_one_1_Please_EOBr": "1. قم بتنزيل القالب التالي وتعبئته.",
  "CS_one_Applicable_States_HNdh": "الدولة ذات الصلة",
  "CS_translation_Submission_akuK": "إرسال",
  "CS_one_Basic_information_akKk": "معلومات أساسية",
  "CS_Page_Driver_Mobile_mQCL": "رقم جوّال الشريك الكابتن",
  "CS_one_Father_classification_ZASx": "المستوى 1 للفئة الأصلية (ar_EG)",
  "CS_info_Select_user_WEYA": "يُرجى تحديد \"نوع المستخدم\" و\"نوع العمل\" لعرض \"أسباب الاتصال\" المتوفرة",
  "CS_information_Order_Status_ZZvi": "حالة المشوار",
  "CS_Page_Please_choose_SkUr": "يُرجى تحديد...",
  "CS_one_Import_data_zhsI": "استيراد البيانات",
  "CS_one_Applicable_Business_ERQA": "نوع العمل ذو الصلة",
  "CS_1_Off_aqDQ": "إغلاق",
  "CS_info2__unk_MkzP": "تحميل صورة",
  "CS_qa_Successfully_saved_GaYt": "تم حفظ تذكرة الدعم بنجاح.",
  "CS_info2_User_Type_ylaU": "نوع المستخدم",
  "CS_1_Send_asynchronous_rowd": "إرسال رسالة واردة إلى التطبيق ورسالة بريد إلكتروني",
  "CS_1_Cancel_UVIs": "إلغاء",
  "CS_info2_link_Text_Gvnh": "المعلومات المرتبطة",
  "CS_Page_Enter_Passenger_vcdv": "أدخل رقم تعريف الراكب",
  "CS_one_Cancel_sSYi": "إلغاء",
  "CS_one_Add_VToU": "إضافة",
  "CS_one_Download_Template_XYvP": "تنزيل القالب",
  "CS_tickets_Compensation_Deducperiod_HFiB": "وقت تنفيذ التعويض/الخصم",
  "CS_info2_Picture_text_mnMQ": "وصف الصورة",
  "CS_1_User_Mobile_aNYY": "رقم الجوّال للمستخدم",
  "CS_Page_Product_line_gPCE": "خط المنتج",
  "CS_info_There_is_vxeJ": "لا يوجد محتوى متوفر \"لسبب الاتصال\" هذا. للاطِّلاع على المزيد من المعلومات، يُرجى مراجعة (قاعدة المعرفة).",
  "CS_tickets_Today_klqB": "اليوم",
  "CS_tickets_Search_dVXa": "بحث",
  "CS_improvement_Driver_ZOiL": "الكابتن",
  "CS_one_Scenarios_qeVe": "السيناريو",
  "CS_reconstruction_Determination_MvvP": "تأكيد",
  "CS_2_Time_of_ynEo": "وقت رد المال",
  "CS_1_operator_gItF": "مُنفِّذ الإجراء",
  "CS_info2_Image_address_QJoY": "عنوان URL لصورة",
  "CS_tickets_Type_of_DvxN": "نوع تذكرة الدعم",
  "CS_tickets_Half_a_SjoS": "آخر 6 أشهر",
  "CS_info_Into_the_OLWz": "معلومات مُقدِّم الشكوى",
  "CS_page_Unable_to_sJgg": "يتعذر حل تذكرة الدعم",
  "CS_1_Passengers_rXbp": "الراكب",
  "CS_page_Unable_to_lQkV": "يتعذر إغلاق تذكرة الدعم",
  "CS_1_Compensation_Deduction_eyNT": "تفاصيل التعويض/الخصم",
  "CS_page_Unable_to_lWwm": "يتعذر حفظ تذكرة الدعم مؤقتًا",
  "CS_Page_Passenger_ID_WiFY": "رقم تعريف الراكب",
  "CS_Page_Clear_Query_qLSf": "مسح معايير البحث",
  "CS_info2_View_link_fyZT": "عرض الرابط",
  "CS_tickets_Work_order_STXN": "سجل تذكرة الدعم",
  "CS_2_Copy_successfully_rlpe": "تم النسخ بنجاح",
  "CS_one_Grade_classification_sVNq": "الفئة الأصلية",
  "CS_Page_Driver_Details_Mnzk": "صفحة تفاصيل الكابتن",
  "CS_page_Successful_temporary_sFHU": "تم حفظ تذكرة الدعم مؤقتًا",
  "CS_page_Successfully_created_ffvZ": "تم إنشاء تذكرة الدعم بنجاح",
  "CS_Page_Purpose_rNGk": "موقع النزول",
  "CS_thpoptimization_Copy_the_CPlW": "تم نسخ عنوان البريد الإلكتروني، وتم تسجيل هذا الإجراء. يُرجى الحرص على الالتزام بسياسات أمان المعلومات المتبعة لدى الشركة.",
  "CS_1_Status_of_Dkxj": "الحالة",
  "CS_Adjustment_VsHy_RwJo": "يُرجى إدخال سبب للتخطي",
  "CS_reconstruction_Select_Business_DYpG": "يُرجى تحديد نوع العمل",
  "CS_Settings_Can_not_wuTx": "لا يمكن تركه فارغًا",
  "CS_1_Action_Name_sFel": "الإجراء",
  "CS_Page_Driver_Details_uNcn": "تفاصيل الشريك الكابتن: رقم تعريف الشريك الكابتن",
  "CS_pop_Action_zZIq": "الإجراءات",
  "CS_pop_Confirmation_lTpQ": "موافق",
  "CS_improvement_Phone_records_Kgdt": "سجل الاتصال",
  "Help_buchong_Reply_RcHf": "الرد",
  "CS_one_Classification_of_YYEd": "هل سبب التواصل المُحدد مرتبط بعامل الأمان؟",
  "CS_info2_Association_ZCdq": "ربط",
  "CS_1_Work_orders_fADf": "أُرسلت الرسالة الداخلية بنجاح لتذكرة الدعم",
  "CS_qa_Collapse_DJRI": "عرض أقل",
  "CS_improvement_Voice_duration_TNdW": "مدة الاتصال",
  "CS_1_Work_order_pUHt": "أُرسلت رسالة البريد الإلكتروني بنجاح لتذكرة الدعم",
  "CS_1_Mail_address_Hxvv": "عنوان البريد الإلكتروني",
  "CS_Page_Driver_ID_HNzY": "معرّف الشريك الكابتن",
  "CS_info_Select_a_CKYG": "يُرجى تحديد \"مدينة\". إذا لم تكن هناك مدن متوفّرة، يمكنك تحديد \"غير متوفّر\".",
  "Magellan_improvement_When_you_WyDX": "سيتم إلغاء الطلبات بمجرد إغلاقها. الرجاء الاختيار بعناية.",
  "CS_tickets_Compensation_ID_PjEu": "رقم تعريف التعويض",
  "CS_5_When_the_WPIZ": "مُقدِّم الشكوى هو الكابتن، لذا لا يمكن استخدام سوى أدوات الكابتن.",
  "CS_one_Please_confirm_BmHM": "يُرجى تأكيد أسباب التواصل المحددة ثم النقر على «تأكيد» للتحقق منها.",
  "CS_1_Send_email_oriC": "إرسال بريد إلكتروني",
  "CS_tickets_One_week_YsBK": "آخر أسبوع",
  "CS_page_Whether_the_pGhP": "هل تريد بالتأكيد حل تذكرة الدعم هذه؟ بعد التأكيد، ستتغير حالة التذكرة إلى [جارٍ المعالجة].",
  "CS_one_Off_Zqiv": "إغلاق",
  "CS_2_For_security_YqmP": "تم إخفاء عنوان البريد الإلكتروني للمستلِم لدواعي الأمان. لن يؤثر ذلك على تواصلك معه.",
  "CS_info_Please_fill_yjjm": "يُرجى إدخال رقم الجوّال",
  "CS_info2_Business_Type_KDsP": "نوع العمل",
  "CS_1_Send_internal_kufI": "إرسال رسالة",
  "CS_1_Save_dSGz": "حفظ",
  "CS_page_Priority_processor_Gwtc": "الممثل المفضل المختص بالتذكرة",
  "CS_1_The_author_xIBI": "مِن",
  "CS_one_Details_Page_mdDC": "صفحة تفاصيل سبب التواصل",
  "CS_page_If_you_RZwt": "هل تريد بالتأكيد حفظ تذكرة الدعم هذه مؤقتًا؟ سيؤدي ذلك إلى تغيير حالة التذكرة إلى [محفوظة مؤقتًا].",
  "CS_page_Work_order_vikw": "تم حل تذكرة الدعم بنجاح",
  "CS_1_Type_kuvZ": "النوع",
  "CS_1_Role_QhMU": "الدور",
  "CS_one_Please_confirm_ViBj": "يُرجى تأكيد أسباب التواصل المحددة ثم النقر على «تأكيد» لتجاهلها.",
  "CS_2_Refund_history_NZXS": "سجل عمليات رد المال",
  "CS_info2_Related_Worksheets_TnzD": "ربط تذكرة الدعم (اختياري)",
  "CS_Page_City_XSgD": "المدينة",
  "CS_qa_Customer_Service_CeXF": "ممثل خدمة العملاء",
  "CS_Page_Passenger_List_ajVZ": "قائمة الركاب",
  "CS_1_Latest_before_UTUl": "فرز حسب الأحدث",
  "CS_5_Copy_successfully_CcCu": "تم النسخ",
  "CS_1_During_Operation_xWpb": "وقت الإجراء",
  "CS_one_Please_select_IHKO": "يُرجى تحديد الدولة وخط العمل",
  "CS_one_During_Operation_JDju": "وقت الإجراء",
  "CS_qa_More_Paqa": "المزيد",
  "CS_info_Select_Channel_HWlg": "يُرجى تحديد \"قناة\"",
  "CS_info2_Rider_Issuing_TDAx": "وقت طلب مشوار الراكب",
  "ark.global.cs.TOOL_ACTION_associated_ticket": "تم ربط تذكرة دعم",
  "Magellan_improvement_Information_Secure_LRtP": "تذكير بسرية المعلومات",
  "CS_Page_Enter_driver_CirL": "أدخِل معرّف الشريك الكابتن",
  "CS_Page_Select_driver_rrhQ": "يُرجى تحديد نوع الشريك الكابتن",
  "CS_qa_There_is_vPke": "هناك محتوى غير مُرسَل في {{inputbox}}، وستؤدي مغادرة هذه الصفحة إلى مسح المحتوى. هل أنت متأكد من رغبتك في المغادرة؟",
  "CS_one_Father_classification_lZII": "المستوى 2 للفئة الأصلية (ar_EG)",
  "CS_info_Mobile_phone_SGyc": "يتعذّر العثور على معلومات المستخدم لأن رقم الجوّال غير صالح أو لأن المستخدم غير مُسّجل.",
  "CS_one_Export_data_YQDj": "تصدير البيانات",
  "CS_information_Departure_zaxW": "نقطة المغادرة",
  "CS_TicketHandlingPage_This_CR_VWpW": "SOP اليدوي مدعوم بالفعل لمعدل الإكمال المذكور. يُرجى معالجة تذكرة الدعم وفقًا لـ SOP.",
  "CS_2_Work_Order_anVq": "مجموعة التذكرة",
  "CS_info_Select_Business_bhhu": "يُرجى تحديد نوع العمل",
  "CS_Adjustment_ZMnG_gsAL": "غير ذلك",
  "CS_information_Order_ID_vVme": "معرف المشوار",
  "CS_one_User_Type_iRnJ": "نوع المستخدم",
  "CS_one_Edit_LtHm": "تعديل",
  "CS_info2_If_there_BivS": "يُرجى تحديد تذكرة دعم مربوطة (إن وُجدت)",
  "CS_Page_Billing_models_otMq": "نوع السيارة",
  "CS_Page_Enter_your_kKAs": "أدخِل رقم الهاتف",
  "CS_page_No_email_Uhdl": "ليس لديك الإذن بإرسال رد على الرسالة الإلكترونية",
  "CS_Adjustment_VZmt_VnjZ": "يُرجى تحديد سبب للتخطي",
  "CS_Adjustment_oVPm_qPQP": "المستخدم غير متصل أو أنه أغلق الدردشة",
  "CS_one_View_miAp": "عرض",
  "CS_fits_OUZR_woGE": "خط منتج الطلبات",
  "CS_1_Compensation_deduction_pTJS": "قناة التعويض/الخصم",
  "CS_info2_More_akQx": "عرض المزيد",
  "CS_1_Work_orders_cLNO": "أُرسلت رسالة واردة إلى التطبيق بنجاح لتذكرة الدعم",
  "CS_1_Roaming_wzIe": "التجوال",
  "CS_5_Copy_qVgF": "نسخ",
  "CS_Page_Star_Standard_ICmt": "التقييم بالنجوم",
  "CS_compensation_Refusal_of_hveW": "تم رفض التعويض",
  "CS_initialization_Select_Order_dqhz": "اختر مشوارًا",
  "CS_TicketHandlingPage_Artificial_SOP_vwXh": "SOP اليدوي",
  "CS_Page_Passenger_Email_qveC": "البريد الإلكتروني للراكب",
  "CS_Page_Between_the_eqMJ": "وقت الإنشاء",
  "CS_Page_Business_Type_nsHy": "نوع العمل",
  "CS_page_Do_you_tMFN": "هل تريد إغلاق تذكرة الدعم هذه؟",
  "CS_2_Work_Order_fABY": "تم نسخ معرّف تذكرة الدعم بنجاح",
  "CS_Page_Pick_up_CNzD": "موقع الالتقاء",
  "More": "المزيد",
  "CS_improvement_Unanswered_qcLt": "لا يوجد رد",
  "CS_1_Related_Orders_hkRo": "ربط الطلب",
  "CS_info_Comments_successfully_YcZj": "تمت إضافة تعليق",
  "CS_tickets_Enter_the_FCWt": "تذكرة دعم مرتبطة بمُقدِّم الشكوى",
  "CS_information_Booking_session_CBQY": "الوقت المحجوز مسبقًا",
  "ark.global.cs.field.values.ticket_tab_inner_reply": "رسالة داخلية",
  "CS_Page_Driver_ID_TPqW": "رقم تعريف الشريك الكابتن",
  "CS_info_Select_Work_KXNc": "يُرجى تحديد \"مجموعة التذكرة\"",
  "Help_conversations_Robot_chat_QzDc": "سجل المحادثات الآلية",
  "CS_tickets_Between_the_mEqx": "وقت الإنشاء",
  "CS_2_Passenger_Basic_FFNN": "معلومات الراكب الأساسية",
  "CS_page_Do_you_GgIB": "هل تريد نقل تذكرة الدعم إلى {{handler}} في {{ticketgroup}}؟",
  "CS_1_Enter_text_NYGo": "أدخِل النص...",
  "CS_1_Compensation_ID_BGFF": "رقم تعريف التعويض",
  "CS_1_Work_order_wyuA": "معلومات تذكرة الدعم",
  "CS_info_Select_User_rSZo": "يُرجى تحديد نوع المستخدم",
  "CS_one_Classification_of_QAlG": "سبب التواصل",
  "ark.global.cs.field.values.ticket_tab_asyc_msg": "رسالة واردة إلى التطبيق",
  "CS_pop_Can_t_QjXi": "ألم تعثر على المكالمة ذات الصلة؟",
  "Help_version_Telephone_entry_PGun": "شريط الهاتف",
  "CS_one_You_can_MflO": "غير مسموح باستخدام الرموز الخاصة، باستثناء «()» و «?» والمسافات",
  "ark.global.cs.field.values.ticket_tab_outer_reply": "رد خارجي",
  "CS_one_operator_Itcg": "المشغِّل",
  "CS_one_Organization_eUqC": "المؤسسة",
  "CS_5_Comply_with_YDuq": "يُرجى اتباع سياسات أمن المعلومات المُطبقة لدى الشركة.",
  "CS_prompt_Driver_registration_mBqS": "لم يتم العثور على مهمة مراجعة تسجيل الكابتن",
  "CS_Page_Order_ID_tWzK": "معرف الطلب",
  "CS_one_Classification_of_jyqM": "سبب التواصل (ar_EG)",
  "CS_Page_Status_of_SBuB": "حالة الدفع",
  "CS_Page_Enter_ID_IgwX": "أدخل رقم التعريف",
  "TEXT_ERRMSG_OK": "تم بنجاح",
  "Help_version_Thread_tmgY": "سبب التواصل",
  "CS_Page_Passenger_Mobile_ckjq": "رقم جوّال الراكب",
  "CS_qa_User_Tjti": "مستخدم",
  "CS_one_Classification_of_AlnN": "سبب التواصل (ar_EG)",
  "CS_1_Help_us_ilXL": "ساعدنا على التحسين",
  "CS_one_Are_you_eqhN": "هل ترغب فعلاً في إنشاء سبب تواصل جديد؟ بعد إنشاء سبب التواصل الجديد، سيسري في الدولة ذات الصلة. يُرجى إخطار الزملاء المعنيين في الدولة المحددة.",
  "CS_initialization_Select_City_uKvx": "اختر مدينة",
  "CS_pop_Bind_fsRd": "تمت الإضافة",
  "CS_2_Classification_of_QmXS": "سبب التواصل",
  "kfcommon-fe-i18n-knowledge---knowledgeConfig.robot": "آليِّون",
  "ark.global.cs.field.title.ticket_tab_log": "سجل تذاكر الدعم",
  "CS_pop_Yes_yDMc": "نعم",
  "CS_tickets_One_year_gmPi": "آخر عام",
  "CS_page_Internal_reply_pruf": "لا يمكن ترك الرد الداخلي فارغًا",
  "ark.global.cs.field.title.ticket_tab_info": "سجل المعلومات",
  "CS_Page_Front_ID_apqL": "تفاصيل أسطول السيارات: رقم تعريف أسطول السيارات",
  "CS_1_User_Name_dhWx": "اسم المستخدم",
  "CS_one_Batch_scrap_qzlO": "تجاهل المجموعة",
  "CS_info2__unk_RIxc": "إدراج",
  "CS_one_Parental_classification_zEhp": "الفئة الأصلية (ar_EG)",
  "Help_buchong_Reply_Record_dsUU": "سجلّ الرد",
  "CS_info2_All_orders_yVmI": "عرض جميع الطلبات لهذا المستخدم في آخر 180 يومًا",
  "CS_1_The_oldest_vXHS": "فرز حسب الأقدم",
  "comTool.channelRefundERR": "لا توجد فاتورة لهذا المشوار. لذلك فلا يمكن رد المال إلى القناة الأصلية.",
  "review.auditInfo": "التفاصيل",
  "list.orderId": "رقم تعريف المشوار",
  "comTool.refundStatus": "حالة استرجاع المال",
  "common.pleaseSelect": "تحديد",
  "new.tags": "العلامات",
  "comfort.vehicleModel": "موديل السيارة",
  "comfort.requiredYear": "سنة >",
  "chat.save": "حفظ",
  "review.submitReview": "إرسال للمراجعة",
  "new.continueHandle": "المتابعة للتعامل مع",
  "comTool.driverV": "يتعذر التعويض نظرًا لأن نوع المستخدم هو \"راكب\"",
  "comTool.balance": "الرصيد",
  "automation.action": "الإجراء",
  "list.compensatePhone": "هاتف المستخدم",
  "staticConfig.false": "لا",
  "work.businessTypeName": "نوع العمل",
  "new.orderInfo": "معلومات الطلب",
  "review.viewFlowchart": "عرض مخطط التدفق",
  "comTool.riderCompensation": "تعويض الراكب",
  "comTool.driverActualRevenue": "العائد الفعلي للكابتن",
  "comTool.driverId": "رقم تعريف الكابتن",
  "new.knowdgeBase": "قاعدة المعرفة",
  "comTool.passenger": "الراكب",
  "list.channel": "القناة",
  "clipper.clipperTitle": "معلومات تذكرة دعم السلامة من فئة ‎Clipper ذات الصلة",
  "comTool.reasonForCompensation": "سبب التعويض",
  "comTool.driverPhone": "رقم هاتف الكابتن",
  "review.commitTime": "وقت الإرسال",
  "common.system": "النظام",
  "common.more": "المزيد",
  "comTool.amountERR": "خطأ في إدخال المبلغ",
  "staticConfig.yes": "نعم",
  "staticConfig.operationSuccessfully": "تمت العملية بنجاح",
  "list.worksheetId": "رقم تذكرة الدعم",
  "comTool.status": "حالة الدفع",
  "comTool.driverDeduction": "خصم الكابتن",
  "new.ticketRefreshV": "تم تحديث تذكرة الدعم هذه، متابعة أم لا؟",
  "common.jingmoThreeMonths": "عرض سجل الصمت على مدى الشهور الثلاثة الأخيرة فقط",
  "comTool.refundCost": "المبلغ المسترد",
  "list.amount": "المبلغ",
  "review.auditor": "تمت المراجعة بواسطة",
  "common.Toolbox": "صندوق الأدوات",
  "common.ticketList": "قائمة تذاكر الدعم",
  "comfort.city": "المدينة",
  "review.taskName": "نوع المهمة",
  "staticConfig.channelSetting": "إعدادات القناة",
  "comTool.detailsOfCompensation": "تفاصيل التعويض",
  "clipper.clipperDetail": "توجد تذكرة دعم السلامة من فئة ‎Clipper ذات صلة بتذكرة الدعم",
  "comTool.driverCompensation": "تعويض الكابتن",
  "review.submitReviewConfirm": "هل متأكد أنك تريد إرسال هذه المعلومات للمراجعة؟",
  "new.uploadFailed": "فشل التحميل. يُرجى إعادة المحاولة",
  "comTool.operationStatus": "النتيجة",
  "clipper.status": "حالة تذكرة Clipper",
  "review.actions": "الإجراءات",
  "comTool.passengerCouponV": "لا يمكن طلب قسيمة، لأن نوع المستخدم كابتن",
  "work.Workbench": "منصة العمل الخاصة بي",
  "comTool.cost": "مبلغ الدفع",
  "chat.transfer": "التحويل البنكي",
  "chat.onlineResponse": "رسالة واردة إلى التطبيق",
  "review.auditTime": "تمت المراجعة في",
  "staticConfig.no": "لا",
  "staticConfig.businessTypeName": "اسم نوع العمل",
  "new.NullEmergencyContact": "لم يقم المستخدم بتعيين جهة اتصال للطوارئ",
  "new.emergencyContact": "جهات اتصال للطوارئ",
  "common.confirm": "تأكيد",
  "comfort.model": "موديل السيارة",
  "clipper.T3first": "وقت المطالبة بتذكرة الدعم بواسطة ‎T3",
  "common.abnormalReminder": "تنبيه بالخطر",
  "new.editTime": "تحرير الوقت",
  "comTool.pay": "محفظة 99Pay للراكب",
  "review.undoChanges": "تراجع عن التغييرات",
  "comTool.channelName": "اسم القناة",
  "callInfo.operation": "العملية",
  "clipper.creationDate": "وقت إنشاء تذكرة الدعم ‎Clipper",
  "common.continueTocompensate": "التعويض على أي حال",
  "comTool.coupon": "قسيمة",
  "list.amountRange": "نطاق المبلغ  ",
  "comTool.channelRefund": "تعويض القناة الأصلية",
  "clipper.ticketID": "رقم تعريف تذكرة الدعم ‎Clipper",
  "comfort.search": "بحث",
  "clipper.T2first": "وقت المطالبة بتذكرة الدعم بواسطة ‎T2",
  "new.PleaseCreateTicket": "يُرجى إنشاء تذكرة الدعم أولاً",
  "comTool.refund": "استرجاع المال",
  "detail.handle": "معالجة",
  "new.fileBig": "الملف كبير جدًا. يُرجى تحديد ملف أصغر من 5 ميجا",
  "create.NewTicket": "تذكرة دعم جديدة",
  "staticConfig.true": "نعم",
  "review.auditResult": "النتيجة",
  "new.editUser": "المحرر",
  "review.modify": "تعديل",
  "detail.handleV": "تذكرة الدعم هذه قيد المعالجة. هل متأكد أنك تريد المطالبة بها؟",
  "new.refreshTicket": "تحديث هذه الصفحة",
  "comTool.routeOfCompensation": "مسار التعويض",
  "common.recommendationNotcompensate": "توصية: لا تُجرِ التعويض.",
  "common.to": "تغيير إلى",
  "comTool.noOrderAll": "لا يوجد طلب لتذكرة الدعم هذه, لذلك لا يمكن التعويض.",
  "clipper.clickToView": "انقر للعرض",
  "common.up": "إخفاء",
  "CS_Tools_1209_Optimus_Coupon_Inuquiry_Scope_of_bBLW": "Rider ID ",
  "CS_4_Topographic_tools_KqUl": "Map",
  "CS_page_Site_Name_dYcm": "Stop Name",
  "CS_page__unk_uZmz": "Minibus Info",
  "CS_page_Cancelled_xyYr": "Cancelled",
  "CS_notification_dwyv_UnUJ": "This inbound user is a fleet partner. Only Fleet tools are applicable.",
  "CS_Tools_1231_Optimus_AdyenTool_Failure_TWRQ": "Unsuccessful",
  "CS_page_Actual_arrival_YPiM": "Actual Arrival Time",
  "CS_page_This_order_jAmf": "Trip Stops",
  "CS_4_Contact_Records_NcjV": "Contact History",
  "CS_4_Order_details_ulUl": "Trip Details",
  "CS_page_Estimated_arrival_QwhV": "Estimated Arrival Time",
  "Help_want__Change_pUeS": "More suggestions",
  "CS_Tools_colombo_tool_platform_Cancel_gNzm": "Cancel",
  "CS_monitor_Each_compensation_BfxO": "All compensation requests are logged. Please ensure requests meet the Customer Service Compensation Policy. Requests that do not meet the policy guidelines will be reviewed internally."
}